module.exports = __webpack_public_path__ + "static/media/empty-layout.d1c655fb.png";